import axios from 'axios';
import { clone } from '../utils/object';

const host = process.env.VUE_APP_URL_API;

export default class Register {
  doRegister(programId, data) {
    this.path = `/checkout/${programId}/register`;
    this.url = host + this.path;

    const payload = clone(data);

    if ('id' in payload && !payload.id) {
      delete payload.id;
    }

    if ('additionals' in payload && !payload.additionals?.[0]?.name) {
      delete payload.additionals;
    }

    return axios.post(this.url, payload);
  }
}
